import React from "react";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  nullTextField: { padding: 8 },
});

export default function CustomerSearchForm(props) {
  const classes = useStyles();
  const {
    handleFetchInfo,
    branchCode,
    accountNumber,
    cifNumber,
    handleChangeBranchCode,
    handleChangeAccountNumber,
    handleChangeCifNumber,
    hiddenCifNumber,
  } = props;

  return (
    <form noValidate>
      <div class="row">
        <div class="col-xs-2" style={{ margin: "8px" }}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            id="branchCode"
            label="店番号"
            name="branchCode"
            value={branchCode}
            onChange={handleChangeBranchCode}
            autoFocus
          />
        </div>
        <div class="col-xs-3" style={{ margin: "8px" }}>
          <div class="row">
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              disabled={!!cifNumber}
              name="accountNumber"
              label="口座番号"
              id="accountNumber"
              value={accountNumber}
              onChange={handleChangeAccountNumber}
            />
            {hiddenCifNumber ? (
              ""
            ) : (
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                disabled={!!accountNumber}
                name="cifNumber"
                label="CIF番号"
                id="cifNumber"
                value={cifNumber}
                onChange={handleChangeCifNumber}
              />
            )}
          </div>
        </div>
        <div class="col-xs-3" style={{ margin: "30px" }}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            className={classes.submit}
            onClick={handleFetchInfo}
          >
            検索
          </Button>
        </div>
      </div>
    </form>
  );
}
